module.exports = __webpack_public_path__ + "img/index-box4-icon5.bd1aea8f.png";